import script from "./UsuarioProximaReservasModificar.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuarioProximaReservasModificar.vue?vue&type=script&setup=true&lang=js"

import "./UsuarioProximaReservasModificar.vue?vue&type=style&index=0&id=75752744&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75752744"]])

export default __exports__